import React, { Component, Fragment } from "react"
import productImg from "../../assets/images/no-product-image.png"
import Async from "react-select"
import leftArrowImage from "../../assets/images/left-arrow.png"
import { connect } from "react-redux";
import Select from "react-select"
import "react-select/dist/react-select.css"
import Modal from "react-responsive-modal";

//services
import {
  CustomerServices,
  UtilityService,
  MeetingNotesServices,
  StyleServices,
  FileUploadService,
  PermissionServices,
  DevelopmentServices
} from "../../services"

//components
import Button from "../../components/Buttons/Button"
import Field from "../../components/Common/Field/Field"
import FileUpload from "../../components/FileUpload/FileUpload"
import CustomerDeptSelect from "../../components/Field/CustomerDeptSelect"
import Audit from "../../components/Common/audit"
import Loading from "../../components/Common/Loading"
import ImageTopLeft from "../../components/ImageTopLeft"

import Picky from "react-picky"
import "react-picky/dist/picky.css" // Include CSS

import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"

const goToTopStyling = {
  padding: "4px",
  border: "0.5px solid #009688",
  backgroundColor: "#009688",
  borderRadius: "5px",
  color: "#fff",
  "& :hover": {
    textDecoration: "none",
    color: "#fff !important"
  }
}

class Style extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,

    filePreviewIframe: '',
    isSaved: false,
    firstRender:true,

    style: {
      styleNumber: null,
      date: null,
      styleOrigination: null,
      customer: null,
      customerDepartmentId: null,
      blockRefNumber: "",
      refDetail: null,
      garmentType: null,
      embroidery: true,
      embelishment: true,
      setType: false,
      styleImage: "",
      MNId: null,
      refImages: [],
      reference: []
    },
    //systemMaster styles
    systemStyleValues: {
      FABRICTYPE: [],
      GARMENTTYPE: [],
      RANGE: [],
      STYLEORIGINATION: []
    },
    customerList: [],
    meetingNoteList: [],
    oldStyleOption: [],
    actionedByOption: [],
    isLoading: false,
    isPositionTop: false,
    openModal: false,
    imageInfo: {
      imageName: '',
      imageType: null,
      path: '',
      url: '',
      imageDescription: '',
      fileName: '',
      fileType: '',
    },
    goBack: -1
  }

  componentWillMount() {
    let action, _id;
    if (this.props.location.state) {
      action = this.props.location.state.action
      _id = this.props.location.state._id
    } else {
      const urlParams = new URLSearchParams(this.props.location.search)
      action = urlParams.get("action")
      _id = urlParams.get("_id")
      let hash = this.props.location.hash
      this.props.history.replace('/StylePage', {
        action, _id, hash
      })
    }

    this.setState({ action, _id })

    if (action == "add") {
      let style = { ...this.state.style }
      if (this.props.location.state.MNId !== null) {
        style.MNId = this.props.location.state.MNId
      }
      style.date = new Date()
      this.setState({
        style
      })
    }

    if (action == "view") {
      this.setState({
        disabled: true
      })
    }

    if (action == "view" || action == "edit") {
      if (_id !== "") {
        StyleServices.getStyleInfo(_id)
          .then(async response => {
            if (response.status == 200) {
              let style = { ...this.state.style }
              Object.keys(style).forEach(keyName => {
                style[keyName] = response.text.data[keyName]
              })
              this.setState({
                style
              })
              if (response.text.data.refDetail) {
                StyleServices.getReferenceInfo(response.text.data.refDetail).then((res) => {
                  this.setState({
                    style: {
                      ...this.state.style,
                      refDetail: res.data ? {
                        label: res.data.refDetail ? res.data.refDetail.referenceCode : "",
                        value: res.data.refDetail ? res.data.refDetail._id : ""
                      } : {}
                    }
                  })
                })
              }
            }
          })
          .catch(error => this.props.getalertMessage("error", error))
      }
    }

    //getSTyle
    this.getStyleInfo("")

    CustomerServices.customerInfo()
      .then(response => {
        if (response.status == 200) {
          this.setState({ customerList: response.text.data })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })

    //meeting note no option
    let by = "MNId"
    MeetingNotesServices.searchAndSelectMeetingId(by)
      .then(async response => {
        if (response.status === 200) {
          this.setState({
            meetingNoteList: response.text.data
          })
        }
      })
      .catch(error => { })

    StyleServices.getStylePrefilledData()
      .then(async response => {
        if (response.status === 200) {
          this.setState({
            systemStyleValues: await response.text.data
          })
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })

    PermissionServices.searchEmploye("")
      .then(async response => {
        if (response.status === 200) {
          this.setState({
            actionedByOption: await response.text.data
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error))

    setTimeout(() => {
      if (
        this.props.history.location &&
        this.props.history.location.state &&
        this.props.history.location.state.hash
      ) {
        let hash = this.props.history.location.state.hash;
        if (/#/.test(hash) == false) {
          hash = `#${hash}`
        }
        this.scrollRef(hash);
      }
    }, 500);
  }

  getStyleInfo = value => {
    if (value !== null) {
      DevelopmentServices.getMagnumStyleNoWithReference(value)
        .then(response => {
          if (response.status === 200) {
            let jsonData = []
            response.text.data.map((info, index) => {
              let objData = {}
              objData.label = info.referenceCode
              objData.value = info.referenceId
              jsonData.push(objData)
            })

            this.setState({ oldStyleOption: jsonData })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  //refImages Style Func start
  changeImg = files => {
    this.setState({
      isLoading: true
    })
    FileUploadService.uploadFile(files[0], "style")
      .then(response => {
        if (response.status === 200) {
          let style = { ...this.state.style }
          style.styleImage = response.text.data.url
          this.setState({
            style,
            isLoading: false
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  //RefImages style end

  //save style
  creatStyle = e => {
    e.preventDefault()

    let style = { ...this.state.style }

    if (this.state._id !== "") {
      style._id = this.state._id
    }
    // Object.keys(style).forEach(keyname => {
    //   if (
    //     style[keyname] !== null &&
    //     typeof style[keyname] == "object" &&
    //     !style[keyname].isArray &&
    //     keyname != "date"
    //   ) {
    //     style[keyname] = style[keyname].value;
    //   }
    // });

    // style.reference = style.reference.map(ref => {
    //   let data = { ...ref }
    //   if (data.range && data.range.length > 0) {
    //     data.range = data.range.map(dat => {
    //       return dat !== "" ? dat.value : dat
    //     })
    //   }
    //   return data
    // })

    StyleServices.createStyle(style)
      .then(response => {
        if (response.status === 200) {
          let style = response.text.data
          style.styleNumber = response.text.data.styleNumber
          if (this.state._id != "") {
            delete style.reference
          }
          this.props.getalertMessage("success", response.text.message)

          this.setState({
            style: { ...this.state.style, ...style },
            _id: response.text.data._id
          })
        } else if (response.status === 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  searchMeetingNote = e => {
    e.preventDefault()
    MeetingNotesServices.searchAndSelectMeetingId(
      this.state.searchMeetingNotesBy,
      this.state.meetingNoteValue
    )
      .then(response => {
        if (response.message === "List Displayed") {
          this.setState({ meetingNotes: response.data })
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  //reference start func
  // addReferenceCount = () => {
  //   StyleServices.getQRCodeForReferenceStyle(this.state._id)
  //     .then(response => {
  //       if (response.status === 200) {
  //         let style = { ...this.state.style }
  //         style.reference = [{ ...response.text.data, fabricType: "" }, ...style.reference]
  //         this.setState({ style })
  //       }
  //       response.status === 401 && this.props.unauthorisedFunc()
  //     })
  //     .catch(error => {
  //       this.props.getalertMessage("error", error)
  //     })
  // }
  addReferenceCount = () => {
    const { style } = this.state;
    // this.state.isSaved = false;
  
    // Check if there are any references
    if (style.reference.length > 0) {
      const lastIndex = 0;
      const lastReference = style.reference[lastIndex];
      //console.log(lastReference, "lastReference", lastIndex,"las");

      if(this.state.firstRender){
        this.setState({firstRender:false})
        // this.props.getalertMessage("error", "Please save the current reference before adding a new one.");
        //  return; // Prevent adding a new reference
      }else if (this.state.isSaved === false) {
         this.props.getalertMessage("error", "Please save the current reference before adding a new one.");
         return; // Prevent adding a new reference
       }
  
      // Perform validation on the last reference
      if (
        !this.validateArrayObject2(lastReference, "actionedBy", "") ||
        !this.validateArrayObject2(lastReference, "fabricType", "") ||
        !this.validateArrayObject2(lastReference, "magnumStyleName", "")
      ) {
        this.props.getalertMessage("error", "Please fill all required fields in the last reference.");
        return; // Prevent adding a new reference if validation fails
      }
    }
    this.setState({isSaved:false})
  
    // Proceed to add a new reference if validation passes
    StyleServices.getQRCodeForReferenceStyle(this.state._id)
      .then(response => {
        if (response.status === 200) {
          let updatedStyle = { ...this.state.style };
          updatedStyle.reference = [
            { ...response.text.data, fabricType: "" },
            ...updatedStyle.reference
          ];
          this.setState({ style: updatedStyle });
        }
  
        if (response.status === 401) {
          this.props.unauthorisedFunc();
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error);
      });
  };

  //remove reference func
  removeReferenceCount = index => {
    let style = { ...this.state.style }
    StyleServices.deleteReference1(this.state._id, style.reference[index].referenceCode)
      .then(res => {
        if (res.status == 200) {
          style.reference = style.reference.filter(function (item, i) {
            return i !== index
          })
          this.setState({
            style
          })
          this.props.getalertMessage("error", res.text.message)
        }
        if (res.status == 401) {
          this.props.unauthorisedFunc()
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  //RefImages Reference Start
  changeImgForReference = (files, index) => {
    let style = { ...this.state.style }
    let reference = [...style.reference]

    this.setState({
      isLoading: true
    })

    FileUploadService.uploadFile(files[0], "styleReference")
      .then(response => {
        if (response.status === 200) {
          reference[index].sketchImage = response.text.data.url
          style.reference = reference
          this.setState({
            style,
            isLoading: false
          })
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => {
        this.props.getalertMessage("error", error.toString())
      })
  }

  removeRefImage = index => {
    let style = { ...this.state.style }
    style.reference[index].sketchImage = ""
    this.setState({
      style
    })
  }

  //RefImages Reference end

  createReference = (e, index) => {
    e.preventDefault()
    var style = { ...this.state.style }
    let reference = [...style.reference]
    reference[index].styleId = this.state._id
    if (
      typeof reference[index].actionedBy == "object" &&
      !Array.isArray(reference[index].actionedBy)
    ) {
      reference[index].actionedBy = reference[index].actionedBy.value
    }

    reference[index].range = reference[index].range.map(data => {
      return data !== "" ? data.value : data
    })
    StyleServices.createReference(reference[index])
      .then(response => {
        if (response.status === 200) {
          this.props.getalertMessage("success", response.text.message)
          reference[index] = response.text.data.reference[0]
          style.reference = reference
          this.setState({ style })
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
        response.status === 401 && this.props.unauthorisedFunc()
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  createOption = e => {
    e.preventDefault()
    if (this.state.style.styleNumber !== null) {
      var style = { ...this.state.style }

      StyleServices.getQRCodeForReferenceStyle(this.state._id)
        .then(response => {
          if (response.status == 200) {
            let referenceobj = { ...response.text.data }
            style.reference.push(referenceobj)
            this.setState({ style })
            this.props.getalertMessage("success", response.text.message)
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => {
          this.props.getalertMessage("error", error)
        })
    }
  }

  changeGarment = garmentType => {
    let style = { ...this.state.style }
    style.garmentType = garmentType
    this.setState({ style })
  }

  getStyleOrigination = value => {
    StyleServices.getStyleOrigination(value)
      .then(response => {
        if (response.status === 200) {
          if (
            Array.isArray(response.text.data.styleOrigination) &&
            response.text.data.styleOrigination.length > 0
          ) {
            this.setState({
              styleOrigination: response.text.data.styleOrigination
            })
          }
        }
      })
      .catch(error => { })
  }

  changeStyleOrigination = styleOriginationVal => {
    let style = { ...this.state.style }
    style.styleOrigination = styleOriginationVal.value
    this.setState({ style })
  }

  getActionedBy = value => {
    if (value !== null) {
      PermissionServices.searchEmploye(value)
        .then(async response => {
          if (response.status === 200) {
            let actionedByOption = []
            actionedByOption = await [...response.text.data]
            this.setState({
              actionedByOption
            })
          }
        })
        .catch(error => this.props.getalertMessage("error", error))
    }
  }

  changeActionedBy = (actionedByData, index) => {
    let style = { ...this.state.style }
    style.reference[index].actionedBy = actionedByData
    this.setState({ style })
  }

  //getMeetingIdList
  getMeetingIdList = value => {
    let by = "MNId"
    if (value !== "") {
      MeetingNotesServices.searchAndSelectMeetingId(by, value)
        .then(async response => {
          if (response.status === 200) {
            this.setState({
              meetingNoteList: response.text.data
            })
          }
        })
        .catch(error => {
          alert("Something Went Wrong...Try Again Later")
        })
    }
  }
  changeMeetingId = meetingIdVal => {
    let style = { ...this.state.style }
    if (meetingIdVal) {
      style.MNId = meetingIdVal.value
    } else {
      style.MNId = null
    }
    this.setState({ style })
  }

  _handleInputChange = (name, value) => {
    let style = { ...this.state.style }
    style[name] = value
    this.setState({
      style
    })
  }

  _handleInputChangeForReference = (name, value, index) => {
    let style = { ...this.state.style }
    if (name === "magnumStyleName") {
      // Remove leading whitespace
      const sanitizedValue = value
      .replace(/^\s+/, "") // Remove leading whitespace
      .replace(/\s{3,}/g, "  "); // Replace more than two spaces with two spaces
      //console.log(sanitizedValue, "sanitizedValue");
    style.reference[index][name] = sanitizedValue;
    } else {
      // Update other fields as is
      style.reference[index][name] = value;
    }
    this.setState({
      style
    })
  }

  _handleCustDeptChange = (index, customer, customerDepartmentId) => {
    let style = { ...this.state.style }
    style.customer = customer
    style.customerDepartmentId = customerDepartmentId
    this.setState({ style })
  }

  changeOldRef = val => {
    let style = { ...this.state.style }
    if (val) {
      style.refDetail = val.value
    } else {
      style.refDetail = null
    }
    this.setState({ style })
  }

  getRefImages = refImages => {
    let style = { ...this.state.style }
    style.refImages = refImages
    this.setState({ style })
  }

  getRefImagesForReference = (refImages, index) => {
    let style = { ...this.state.style }
    style.reference[index].refImages = refImages
    this.setState({ style })
  }

  removeStyleImage = () => {
    let style = { ...this.state.style }
    style.styleImage = ""
    this.setState({
      style
    })
  }

  detectScroll = () => {
    var ele = document.getElementById("right-sec")
    this.setState({
      isPositionTop: ele.scrollTop === 0 ? false : true
    })
  }

  scrollRef = (data) => {
    if (this.props.location.state && this.props.location.state.hash) {
      this.setState({ isLoading: true })
      var elmnt = document.getElementById(data)
      console.log(elmnt, "elmntelmnt");

      if (elmnt != null) {
        elmnt.scrollIntoView({
          block: "start",
          behavior: "instant",
          inline: "start"
        })
      }
      this.setState({ isLoading: false })
    }
  }

  // componentDidUpdate() {
  //   function scrollRef(data) {
  //     var elmnt = document.getElementById(data)
  //     if (elmnt != null) {
  //       elmnt.scrollIntoView({
  //         block: "start",
  //         behavior: "instant",
  //         inline: "start"
  //       })
  //     }
  //     this.setState({ isLoading: false })
  //   }

  //   if (this.props.location.state && this.props.location.hash) {
  //     this.setState({ isLoading: true })
  //     scrollRef(this.props.location.hash)
  //   }
  // }

  // componentDidMount() {
  //   if (this.props.location.state && this.props.location.state.hash) {
  //     this.setState({ isLoading: true })
  //     setTimeout(() => {
  //       var elmnt = document.getElementById(`#${this.props.location.state.hash}`)
  //       if (elmnt != null) {
  //         elmnt.scrollIntoView({ behavior: "instant", block: "center" })
  //         this.setState({ isLoading: false })
  //       }
  //       this.props.location.state.hash = null
  //     }, 1000)
  //   }
  //    else {
  //     this.setState({ isLoading: true })
  //     setTimeout(() => {
  //       var elmnt = document.getElementById(`${this.props.location.hash}`)
  //       if (elmnt != null) {
  //         elmnt.scrollIntoView({ behavior: "instant", block: "center" })
  //         this.setState({ isLoading: false })
  //       }
  //       this.props.location.hash = null
  //     }, 1000)
  //     this.setState({ isLoading: false })
  //   }

  // }

  checkValidation = (data, element) => {
    if (
      this.validateArrayObject(this.state.style, "styleOrigination", null) &&
      this.validateArrayObject(this.state.style, "customer", null) &&
      this.validateArrayObject(this.state.style, "garmentType", null)
    ) {
      this.creatStyle(element)
    } else {
      this.props.getalertMessage("error", "Please fill all mandatory fields")
    }
  }

  validateArrayObject(data, key, val) {
    let values = data[key] !== val ? true : false
    return values
  }

  checkValidation2 = (data, index, element) => {
    //this.state.isSaved=true
    if (
      this.validateArrayObject2(
        this.state.style.reference[index],
        "actionedBy",
        ""
      ) &&
      this.validateArrayObject2(
        this.state.style.reference[index],
        "fabricType",
        ""
      ) &&
      this.validateArrayObject2(
        this.state.style.reference[index],
        "magnumStyleName",
        ""
      )
    ) {
      this.createReference(element, index)
      this.setState({ isSaved: true })
    } else {
      this.props.getalertMessage("error", "Please fill all mandatory fields")
    }
  }

  validateArrayObject2(data, key, val) {
    if (key === "magnumStyleName") {
      // Check if the magnumStyleName is empty or contains only whitespace
      if (!data[key] || data[key].trim() === "") {
        return false; // Invalid if empty or whitespace-only
      }
    }
    if (!data[key]) {
      return false
    } else {
      let values = data[key] !== val ? true : false
      return values
    }

  }

  deleteFunc = id => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <button onClick={onClose} className="close" style={{position:"absolute",right:"40px",top:"15px"}}>X</button>
            <h2>Are you sure?</h2>
            <p style={{marginBottom:"17px"}}>You want to delete this Reference?</p>
            <button type="button" class="primary" onClick={onClose}>
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              onClick={() => {
                // this.setState({
                //   isLoading: true
                // });
                this.removeReferenceCount(id)
                this.setState({firstRender:true})
                onClose()
              }}
            >
              Yes, Delete it!
            </button>
          </div>
        )
      },
      closeOnClickOutside: true
    })
    
  }

  modalData = (data) => {
    let filePreviewIframe = this.state.filePreviewIframe
    filePreviewIframe = (<img src={UtilityService.fileUrl() + data} />)
    this.setState({ filePreviewIframe, openModal: true })
  }


  goBackStyle = () => {
    const { style, isSaved, goBack } = this.state;
  
    // Check if there are any references
    if (style.reference.length > 0) {
      const lastReference = style.reference[0];
  
      // Validate the fields of the last reference
      const isValid =
        this.validateArrayObject2(lastReference, "actionedBy", "") &&
        this.validateArrayObject2(lastReference, "fabricType", "") &&
        this.validateArrayObject2(lastReference, "magnumStyleName", "");
  
      if (!isValid) {
        // Validation failed, show a message to save the reference
        confirmAlert({
          customUI: ({ onClose }) => (
            <div className="p-5 text-center">
              <button onClick={onClose} className="close" style={{position:"absolute",right:"40px",top:"15px"}}>X</button>
              <h2>Save the Reference</h2>
              <p>The last style reference is not saved. Please save it before exiting.</p>
              <button
                type="button"
                className="primary"
                style={{ width: "20%" }}
                onClick={onClose}
              >
                OK
              </button>
            </div>
          ),
          closeOnClickOutside: true,
        });
        return; // Prevent navigation
      }
  
      if (!isSaved && !this.state.firstRender) {
        this.setState({ firstRender: false });
        // Show confirmation if there are unsaved changes
        confirmAlert({
          customUI: ({ onClose }) => (
            <div className="p-5 text-center">
              <button onClick={onClose} className="close" style={{position:"absolute",right:"40px",top:"15px"}}>X</button>
              <h2>Save the Reference</h2>
              <p>The last style reference is not saved. Please save it before exiting.</p>
              <button
                type="button"
                className="primary"
                style={{ width: "20%" }}
                onClick={onClose}
              >
                OK
              </button>
            </div>
          ),
          closeOnClickOutside: true,
        });
        return; // Prevent further action
      }
  
      // If validation is successful and saved, ask for confirmation to leave
      confirmAlert({
        customUI: ({ onClose }) => (
          <div className="p-5 text-center">
            <button onClick={onClose} className="close" style={{position:"absolute",right:"40px",top:"15px"}}>X</button>
            <h2>Are you sure?</h2>
            <p> You want to leave this page?</p>
            <button
              type="button"
              className="primary"
              style={{ width: "20%", marginRight: "10px" }}
              onClick={() => {
                onClose(); // Close modal
                this.navigateBack(); // Proceed with navigation
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>
          </div>
        ),
        closeOnClickOutside: false,
      });
      return; // Prevent navigation
    } else {
      // No references, ask the user if they are sure they want to leave
      confirmAlert({
        customUI: ({ onClose }) => (
          <div className="p-5 text-center">
            <button onClick={onClose} className="close" style={{position:"absolute",right:"40px",top:"15px"}}>X</button>
            <h2>Are you sure?</h2>
            <p> You want to leave this page?</p>
            <button
              type="button"
              className="primary"
              style={{ width: "20%", marginRight: "10px" }}
              onClick={() => {
                onClose(); // Close modal
                this.navigateBack(); // Proceed with navigation
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>
          </div>
        ),
        closeOnClickOutside: false,
      });
      return; // Prevent navigation
    }
  };
  
  // Function to navigate back after confirmation
  navigateBack = () => {
    const { goBack } = this.state;
  
    if (this.props.history.location.state) {
      const { route } = this.props.history.location.state;
  
      if (route) {
        this.props.history.push({
          pathname: `/${route}`,
          state: {
            [route.toLowerCase()]: {
              ...this.props.history.location.state[route.toLowerCase()],
            },
          },
        });
      } else {
        goBack < -1
          ? this.props.history.go(goBack)
          : this.props.history.goBack();
      }
    } else {
      this.props.history.push({
        pathname: "/list",
        state: {
          moduleName: "STYLE",
          type: "list",
        },
      });
    }
  };
  


  // goBackStyle = () => {
  //   const { style, action, firstRender, isSaved, goBack } = this.state;
  
  //   if (style.reference.length > 0) {
  //     const lastReference = style.reference[0];
  //     console.log(lastReference, "re");
  
  //     if (firstRender) {
  //       this.setState({ firstRender: false });
  //     } else if (!isSaved) {
  //       // Alert for unsaved reference
  //       confirmAlert({
  //         customUI: ({ onClose }) => (
  //           <div className="p-5 text-center">
  //             <button onClick={onClose} className="close">X</button>
  //             <h1>Save the Reference</h1>
  //             <p>
  //             The last style reference is not saved. Please save it before exiting
  //             </p>
  //             <button
  //               type="button"
  //               className="primary"
  //               style={{ width: "20%" }}
  //               onClick={onClose}
  //             >
  //               OK
  //             </button>
  //           </div>
  //         ),
  //         closeOnClickOutside: true,
  //       });
  //       return; // Prevent further action
  //     }
  
  //     // Validate the fields of the last reference
  //     if (
  //       !this.validateArrayObject2(lastReference, "actionedBy", "") ||
  //       !this.validateArrayObject2(lastReference, "fabricType", "") ||
  //       !this.validateArrayObject2(lastReference, "magnumStyleName", "")
  //     ) {
  //       confirmAlert({
  //         customUI: ({ onClose }) => (
  //           <div className="p-5 text-center">
  //             <button onClick={onClose} className="close">X</button>
  //             <h1>Save the Reference</h1>
  //             <p>
  //             The last style reference is not saved. Please save it before exiting
  //             </p>
  //             <button
  //               type="button"
  //               className="primary"
  //               style={{ width: "20%" }}
  //               onClick={onClose}
  //             >
  //               OK
  //             </button>
  //           </div>
  //         ),
  //         closeOnClickOutside: true,
  //       });
  //       return; // Prevent further action
  //      }
  
  //     // // Navigate back
  //      //this.navigateBack();
  //   }else {
  //     // If no reference, show confirmation for leaving the page
  //     confirmAlert({
  //       customUI: ({ onClose }) => (
  //         <div className="p-5 text-center">
  //           <button onClick={onClose} className="close">X</button>
  //           <h1>Are you sure?</h1>
  //           <p>There are unsaved changes. Are you sure you want to leave this page?</p>
  //           <button
  //             type="button"
  //             className="primary"
  //             style={{ width: "20%" }}
  //             onClick={() => {
  //               onClose(); // Close modal
  //               this.navigateBack(); // Proceed with navigation
  //             }}
  //           >
  //             Yes
  //           </button>
  //           <button
  //             type="button"
  //             className="secondary"
  //             style={{ width: "20%" }}
  //             onClick={onClose}
  //           >
  //             No
  //           </button>
  //         </div>
  //       ),
  //       closeOnClickOutside: false,
  //     });
  //     return; // Prevent navigation
  //   }
  //   // if(style.reference.length === 0){
  //   //   confirmAlert({
  //   //     customUI: ({ onClose }) => (
  //   //       <div className="p-5 text-center">
  //   //         <button onClick={onClose} className="close">X</button>
  //   //         <h1>Save the Reference</h1>
  //   //         <p>
  //   //         The last style reference is not saved. Please save it before exiting
  //   //         </p>
  //   //         <button
  //   //           type="button"
  //   //           className="primary"
  //   //           style={{ width: "20%" }}
  //   //           onClick={onClose}
  //   //         >
  //   //           OK
  //   //         </button>
  //   //       </div>
  //   //     ),
  //   //     closeOnClickOutside: true,
  //   //   });
  //   //   return; 
  //   // }
  // };
  
  // navigateBack = () => {
  //   const { goBack } = this.state;
  
  //   if (this.props.history.location.state) {
  //     const { route } = this.props.history.location.state;
  
  //     if (route) {
  //       this.props.history.push({
  //         pathname: `/${route}`,
  //         state: {
  //           [route.toLowerCase()]: {
  //             ...this.props.history.location.state[route.toLowerCase()],
  //           },
  //         },
  //       });
  //     } else {
  //       goBack < -1
  //         ? this.props.history.go(goBack)
  //         : this.props.history.goBack();
  //     }
  //   } else {
  //     this.props.history.push({
  //       pathname: "/list",
  //       state: {
  //         moduleName: "STYLE",
  //         type: "list",
  //       },
  //     });
  //   }
  // };
  

  // goBackStyle = () => {
  //   const { style, action, firstRender, isSaved, goBack } = this.state;
  
  //   // Check if there are any references
  //   if (style.reference.length > 0) {
  //     const lastReference = style.reference[0];
  //     console.log(lastReference, "re");
  
  //     // Handle first render logic
  //     if (firstRender) {
  //       this.setState({ firstRender: false });
  //       return;
  //     }
  
  //     // Validate the fields of the last reference
  //     if (
  //       !this.validateArrayObject2(lastReference, "actionedBy", "") ||
  //       !this.validateArrayObject2(lastReference, "fabricType", "") ||
  //       !this.validateArrayObject2(lastReference, "magnumStyleName", "")
  //     ) {
  //       // Show alert if validation fails
  //       confirmAlert({
  //         customUI: ({ onClose }) => (
  //           <div className="p-5 text-center">
  //             <button onClick={() => onClose()} className="close">X</button>
  //             <h1>Incomplete Reference</h1>
  //             <p>
  //               The last reference of the style is incomplete. Please fill in the
  //               required fields or delete the reference before exiting.
  //             </p>
  //             <button
  //               type="button"
  //               className="primary"
  //               style={{ width: "20%" }}
  //               onClick={() => onClose()}
  //             >
  //               OK
  //             </button>
  //           </div>
  //         ),
  //         closeOnClickOutside: true,
  //       });
  //       return; // Prevent navigation
  //     }
  
  //     // Check if the reference is saved
  //     if (!isSaved) {
  //       confirmAlert({
  //         customUI: ({ onClose }) => (
  //           <div className="p-5 text-center">
  //             <button onClick={() => onClose()} className="close">X</button>
  //             <h1>Save the Reference</h1>
  //             <p>
  //               The last reference of the style is not saved. Please save the
  //               reference before exiting.
  //             </p>
  //             <button
  //               type="button"
  //               className="primary"
  //               style={{ width: "20%" }}
  //               onClick={() => onClose()}
  //             >
  //               OK
  //             </button>
  //           </div>
  //         ),
  //         closeOnClickOutside: true,
  //       });
  //       return; // Prevent adding a new reference
  //     }
  
  //     // Handle navigation
  //     if (this.props.history.location.state) {
  //       const { route } = this.props.history.location.state;
  //       if (route !== undefined) {
  //         this.props.history.push(`/${route}`, {
  //           [`${route.toLowerCase()}`]: {
  //             ...this.props.history.location.state[`${route.toLowerCase()}`],
  //           },
  //         });
  //       } else if (goBack < -1) {
  //         this.props.history.go(goBack);
  //       } else {
  //         this.props.history.goBack();
  //       }
  //     } else {
  //       this.props.history.push({
  //         pathname: "/list",
  //         state: {
  //           moduleName: "STYLE",
  //           type: "list",
  //         },
  //       });
  //     }
  //   } else {
  //     // Handle navigation when there are no references
  //     if (this.props.history.location.state) {
  //       const { route } = this.props.history.location.state;
  //       if (route !== undefined) {
  //         this.props.history.push(`/${route}`, {
  //           [`${route.toLowerCase()}`]: {
  //             ...this.props.history.location.state[`${route.toLowerCase()}`],
  //           },
  //         });
  //       } else if (goBack < -1) {
  //         this.props.history.go(goBack);
  //       } else {
  //         this.props.history.goBack();
  //       }
  //     } else {
  //       this.props.history.push({
  //         pathname: "/list",
  //         state: {
  //           moduleName: "STYLE",
  //           type: "list",
  //         },
  //       });
  //     }
  //   }
  // };
  

  render() {
    const { style, systemStyleValues } = this.state
    //console.log(this.state.isSaved,"issaved",this.state.firstRender,"fr")
    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div
          id="right-sec"
          class="right-section bg-white"
        // onScroll={e => this.detectScroll()}
        >
          <div class="row nopadding">
            <form id="addStyle">
              <div class="col-md-12 nopadding">
                <div class="col-md-12 no-padding">
                  {/**Left section of above div */}
                  <div className="left-content-section-style no-padding">
                    <div className="col text-center bg-none pb-5">
                      <h4 className="text-green font-lg font-weight-bold mt-2">
                        {this.state.style.styleNumber !== null
                          ? this.state.style.styleNumber
                          : ""}
                      </h4>
                      <div className="col nopadding mt-2">
                        <ImageTopLeft
                          image={style.styleImage}
                          removeImage={this.removeStyleImage}
                          fileUpload={this.changeImg}
                          disabled={this.state.disabled}
                          modalData={this.modalData}
                        />
                      </div>
                    </div>
                  </div>
                  {/**Right section of above div */}
                  <div className="right-content-section-style overflow-scroll ">
                    <div class="col-md-12 text-center p-2">
                      <div className="flex-header-style">
                        <div
                          class={
                            this.state.isPositionTop ? "position-top-back" : ""
                          }
                        >
                          <span
                            className="p-2 cursor-hover text-left"
                            onClick={() => {
                              this.goBackStyle()
                              // if (this.props.history.location.state) {
                              //   const { route } = this.props.history.location.state
                              //   route !== undefined
                              //     ? this.props.history.push(`/${route}`, {
                              //       [`${route.toLowerCase()}`]: {
                              //         ...this.props.history.location.state[
                              //         `${route.toLowerCase()}`
                              //         ]
                              //       }
                              //     })
                              //     : this.state.goBack < -1
                              //       ? this.props.history.go(this.state.goBack)
                              //       : this.props.history.goBack()
                              // } else {
                              //   this.props.history.push({
                              //     pathname: "/list",
                              //     state: {
                              //       moduleName: 'STYLE',
                              //       type: "list"
                              //     }
                              //   })
                              // }

                            }
                            }
                          >
                            <img width={"20px"} src={leftArrowImage} />
                          </span>
                        </div>
                        <div id="top">
                          <h6>Style</h6>
                        </div>
                        <div>
                          <Audit _id={this.state._id} moduleName="style" />
                          <button
                            type="button"
                            class="primary pull-right bulk-padding-margin px-3 py-1"
                          >
                            <i className="material-icons font-for-icon-big">
                              file_download
                            </i>
                          </button>
                          <button
                            type="button"
                            class="primary pull-right bulk-padding-margin px-3 py-1"
                          >
                            <i className="material-icons font-for-icon-big">
                              print
                            </i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      {/* <div class="col-md-12 no-padding"> */}
                      <div class="col-md-2 step-one pr-0">
                        <Field
                          isFormGroup={true}
                          inputType="date"
                          inputName="date"
                          label="Date"
                          value={style.date}
                          onChange={this._handleInputChange}
                          disabled={true}
                        />
                      </div>
                      <div class="col-md-2 pr-0">
                        <label for="item">Meeting Note No</label>
                        <div class="custom-async-select">
                          <Async
                            name="MNId"
                            value={style.MNId}
                            onInputChange={this.getMeetingIdList}
                            onChange={val => this.changeMeetingId(val)}
                            placeholder="Meeting Id"
                            options={this.state.meetingNoteList}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                      <div class="col-md-3 pr-0">
                        {/* <div class="">
                          <label for="ref-no">Style Origination</label>
                          <div className="custom-async-select">
                            <Async
                              name="styleOrigination"
                              value={style.styleOrigination}
                              onInputChange={this.getStyleOrigination}
                              onChange={val => this.changeStyleOrigination(val)}
                              placeholder="Style Origination"
                              options={systemStyleValues.STYLEORIGINATION}
                              disabled={this.state.disabled}
                            />
                          </div>
                        </div> */}
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="styleOrigination"
                          label="Style Origination*"
                          value={style.styleOrigination}
                          options={
                            this.state.systemStyleValues.STYLEORIGINATION
                          }
                          onChange={this._handleInputChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      {/* </div> */}
                      <div class="col-md-3 step-one pt-1">
                        <CustomerDeptSelect
                          options={this.state.customerList}
                          value={`${style.customer}-${style.customerDepartmentId}`}
                          onChange={this._handleCustDeptChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 step-one pr-0">
                        <div class="form-group">
                          <label for="ref-no">Old Magnum Ref</label>
                          <div className="custom-async-select">
                            <Async
                              name="refDetail"
                              value={style.refDetail}
                              onInputChange={this.getStyleInfo}
                              onChange={val => this.changeOldRef(val)}
                              placeholder="Find style no."
                              options={this.state.oldStyleOption}
                              disabled={this.state.disabled}
                              onSelectResetsInput={false}
                              onBlurResetsInput={false}
                            />
                            <br />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 step-one pr-0">
                        <Field
                          isFormGroup={true}
                          inputType="text"
                          inputName="blockRefNumber"
                          label="Block ref number"
                          value={style.blockRefNumber}
                          onChange={this._handleInputChange}
                          disabled={this.state.disabled}
                        />
                      </div>
                      <div class="col-md-2 step-one pr-0">
                        <Field
                          isFormGroup={true}
                          inputType="select"
                          inputName="garmentType"
                          label="Garment Type*"
                          value={style.garmentType}
                          options={systemStyleValues.GARMENTTYPE}
                          onChange={this._handleInputChange}
                          disabled={this.state.disabled}
                        />
                        {/* <div class="form-group">
                          <label for="phone">Garment Type</label>
                          <div className="custom-async-select">
                            <Async
                              name="garmentType"
                              value={style.garmentType}
                              onChange={val =>
                                this.changeGarment(val.value)
                              }
                              placeholder="Find garment"
                              options={systemStyleValues.GARMENTTYPE}
                              disabled={this.state.disabled}
                            />
                          </div>
                        </div> */}
                      </div>
                      <div class="col-md-6 step-one pr-0">
                        <div class="col-md-4">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="embroidery"
                            value={style.embroidery}
                            label="Embroidery"
                            onChange={this._handleInputChange}
                            disabled={this.state.disabled}
                          />
                        </div>
                        <div class="col-md-4">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="embelishment"
                            value={style.embelishment}
                            label="Embelishment"
                            onChange={this._handleInputChange}
                            disabled={this.state.disabled}
                          />
                        </div>
                        <div class="col-md-4">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="setType"
                            value={style.setType}
                            label="set"
                            onChange={this._handleInputChange}
                            disabled={this.state.disabled}
                          />
                        </div>
                      </div>
                    </div>
                    {/**Upload image section */}
                    <div class="col-md-12 col px-5 mt-3">
                      <FileUpload
                        Heading="Upload Images"
                        moduleName={"style"}
                        getRefImages={this.getRefImages}
                        disabled={this.state.disabled}
                        uploadedDocs={
                          style.refImages.length > 0 ? style.refImages : null
                        }
                        imageTypeOption={
                          this.state.systemStyleValues.IMAGETYPE
                            ? this.state.systemStyleValues.IMAGETYPE
                            : []
                        }
                      />
                    </div>
                    {/* ENd of image upload section */}
                    <div class="col-md-12 profile-btn text-center pb-2">
                      {this.state._id != "" && style.reference.length == 0 && (
                        <Button
                          buttonType="save"
                          buttonName="Create Option"
                          onClick={
                            !this.state.disabled
                              ? this.createOption
                              : () => {
                                this.props.getalertMessage(
                                  "info",
                                  "View option only enable"
                                )
                              }
                          }
                        />
                      )}
                      <Button
                        buttonType="save"
                        buttonName="Save"
                        onClick={
                          !this.state.disabled
                            ? e => this.checkValidation("save", e)
                            : () => {
                              this.props.getalertMessage(
                                "info",
                                "View option only enable"
                              )
                            }
                        }
                      />
                      <Button
                        buttonType="save"
                        buttonName="Back"
                        onClick={() => this.goBackStyle()}
                      />
                    </div>
                    {/**end of right section in above div */}
                  </div>
                </div>
                {/** next div */}
                {/* ----------------------------------------------------------------------------------- */}
                {/* Reference option section start */}
                {style.styleNumber !== null &&
                  style.reference.length > 0 &&
                  style.reference.map((data, index) => (
                    <div
                      class="col-md-12 nopadding mt-3"
                      id={`#seleted${data.referenceCode.split("-").join("")}`}
                    >
                      <div class="col-md-12 nopadding">
                        <div class="left-content-section-style nopadding">
                          <div className="col text-center bg-color ">
                            <div className="col nopadding mt-2">
                              <ImageTopLeft
                                image={data.sketchImage}
                                removeImage={() => this.removeRefImage(index)}
                                fileUpload={files =>
                                  this.changeImgForReference(files, index)
                                }
                                disabled={this.state.disabled}
                                modalData={this.modalData}
                              />
                            </div>
                            <div className="col mt-4 height-for-image-div">
                              <div className="d-flex  align-items-center justify-content-center h-100 ">
                                <img src={data.qrCode} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="right-content-section-style overflow-scroll">
                          <div class="col-md-12 product-form no-padding margin-variation">
                            <div
                              className={
                                index === 0 && this.state.isPositionTop
                                  ? "positioing-end margin-variation-negative position-top"
                                  : "positioing-end margin-variation-negative"
                              }
                            >
                              <a
                                style={
                                  index === 0
                                    ? { display: "block",marginLeft:"7px" }
                                    : { display: "none" }
                                }
                                className={`btn-floating btn-small waves-effect waves-light green pull-right ${this.state.disabled ? "d-none" : ""}`}
                                onClick={e => {
                                  this.addReferenceCount()
                                  // this.setState({
                                  //   goBack: this.state.goBack - 1
                                  // })
                                  // setTimeout(() => {
                                  //   this.props.history.push(
                                  //     `/StylePage#seleted${style.reference[0].referenceCode
                                  //       .split("-")
                                  //       .join("")}`
                                  //   )
                                  // }, 600)
                                }}
                              >
                                <i className="material-icons">add</i>
                              </a>
                              <a
                                // style={
                                //   index !== 0
                                //     ? { display: "block" }
                                //     : { display: "none" }
                                // }
                                class={`btn-floating btn-small waves-effect waves-light red del-sample-size-btn pull-right ${this.state.disabled ? "d-none" : ""
                                  }`}
                                id="del-sample-size-btn pull-rog pull-right"
                                onClick={e => {
                                  if (this.props.rights.web.delete) {
                                    this.deleteFunc(index)
                                  } else {
                                    this.props.getalertMessage('info', "You don't have permission")
                                  }

                                }}
                              // onClick={e => }
                              >
                                <i class="material-icons">clear</i>
                              </a>
                            </div>
                            <div class="col-md-12 no-padding">
                              <div class="col-md-1 step-one">
                                <div class="form-group">
                                  <label for="item">Reference</label>
                                  <span>
                                    <h6>{data.referenceCode}</h6>
                                  </span>
                                </div>
                              </div>
                              <div class="col-md-3 step-one">
                                <div class="form-group">
                                  <label for="item">Range</label>
                                  <div>
                                    <Picky
                                      value={data.range}
                                      options={systemStyleValues.RANGE}
                                      onChange={val =>
                                        this._handleInputChangeForReference(
                                          "range",
                                          val,
                                          index
                                        )
                                      }
                                      open={false}
                                      valueKey="value"
                                      labelKey="label"
                                      multiple={true}
                                      includeSelectAll={true}
                                      manySelectedPlaceholder={"%s selected"}
                                      allSelectedPlaceholder={"%s selected"}
                                      includeFilter={true}
                                      dropdownHeight={300}
                                      placeholder="No Items selected"
                                      disabled={this.state.disabled}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2 step-one pr-0">
                                <div class="form-group">
                                  <label for="phone">
                                    Actioned By
                                    <span className="text-danger madatory-asterisk">
                                      *
                                    </span>
                                  </label>
                                  <div className="custom-async-select">
                                    <Async
                                      name="actionedBy"
                                      value={data.actionedBy}
                                      onFocus={() => this.getActionedBy("")}
                                      // onInputChange={this.getActionedBy}
                                      onChange={data =>
                                        this.changeActionedBy(data, index)
                                      }
                                      placeholder="actionedBy"
                                      options={
                                        this.state.systemStyleValues
                                          .ACTIONEDBY || []
                                      }
                                      disabled={this.state.disabled}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="customerRefNumber"
                                  label=" Customer Ref No"
                                  value={data.customerRefNumber}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="itemNumber"
                                  label="Item No"
                                  value={data.itemNumber}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                            </div>
                            <div class="col-md-12 no-padding">
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="referenceColor"
                                  label="Reference Color"
                                  value={data.referenceColor}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="select"
                                  inputName="fabricType"
                                  value={data.fabricType}
                                  options={systemStyleValues.FABRICTYPE}
                                  label={"Fabric Type*"}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-4 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="magnumStyleName"
                                  label="Magnum Style Name*"
                                  value={data.magnumStyleName}
                                  max={40}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-4 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="text"
                                  inputName="buyerStyleName"
                                  label="Buyer Style Name"
                                  value={data.buyerStyleName}
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                            </div>
                            <div class="col-md-12 no-padding">
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="select"
                                  inputName="season"
                                  label="Season"
                                  value={data.season}
                                  index={index}
                                  options={this.state.systemStyleValues.SEASONS}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                              <div class="col-md-2 step-one pr-0">
                                <Field
                                  isFormGroup={true}
                                  inputType="checkboxToggle"
                                  inputName="washApplicable"
                                  value={data.washApplicable}
                                  label=" wash applicable"
                                  index={index}
                                  onChange={this._handleInputChangeForReference}
                                  disabled={this.state.disabled}
                                />
                              </div>
                            </div>
                          </div>
                          {/**Upload image section  for reference */}
                          <div class="col-md-12 px-5 mt-3">
                            <FileUpload
                              getRefImages={this.getRefImagesForReference}
                              moduleName={"styleReference"}
                              index={index}
                              Heading="Upload Images"
                              uploadedDocs={
                                data.refImages.length > 0
                                  ? data.refImages
                                  : null
                              }
                              imageTypeOption={[]}
                            />
                          </div>
                          {/** end of right section for create option */}
                        </div>
                        <div class="col-md-12 profile-btn text-center mt-3">
                          <button
                            type="button"
                            name="button"
                            class="primary mr-2"
                            onClick={
                              this.state.disabled == false
                                ? e => this.checkValidation2("save", index, e)
                                : () => {
                                  this.props.getalertMessage(
                                    "info",
                                    "View option only enable"
                                  )
                                }
                            }
                          >
                            Save
                          </button>
                          <button
                            type="button"
                            name="button"
                            class="primary mr-2"
                            data-toggle="modal"
                            data-target="#req_modal"
                            onClick={() =>
                              this.props.history.push("/list", {
                                moduleName: "SAMPLEREQUEST",
                                type: "list",
                                referenceId: data._id
                              })
                            }
                          >
                            {" "}
                            View Request
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              this.props.history.push(`/Sample`, {
                                referenceId: data._id,
                                styleId: this.state._id,
                                action: "add",
                                setStyleId: true,
                                _id: ""
                              })
                            }
                            className={`primary m-1 ${this.state.disabled ? "d-none" : ""}`}
                          >
                            Create Request
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              this.props.history.push(`/createIB`, {
                                referenceId: data._id,
                                styleId: this.state._id,
                                action: "add",
                                _id: ""
                              })
                            }
                            className={`primary m-1 ${this.state.disabled ? "d-none" : ""}`}
                          >
                            Create IB
                          </button>
                          <Button
                            buttonName={"View IB"}
                            onClick={() =>
                              this.props.history.push(`/list`, {
                                moduleName: "CREATEIB",
                                type: "list",
                                referenceId: data._id
                              })
                            }
                          />
                          <Button
                            buttonType="save"
                            buttonName="Back"
                            onClick={() => this.goBackStyle()}
                          />
                        </div>
                        {style.styleNumber !== null && (
                          <div class="col-md-12 profile-btn text-center pt-3">
                            <Button
                              buttonName={"View SMV/OB & Thread Consumption"}
                              onClick={() =>
                                this.props.history.push(`/list`, {
                                  moduleName: "SMVTHREAD",
                                  type: "list",
                                  referenceId: data._id
                                })
                              }
                            />
                            <Button
                              buttonName={" SMV/OB & Thread Consumption"}
                              onClick={() =>
                                this.props.history.push(`/SmvThread`, {
                                  styleReferenceId: data._id,
                                  // styleId: this.state._id,
                                  // styleNumber: this.state.style
                                  //   .styleNumber,
                                  action: "add",
                                  _id: ""
                                })
                              }
                            />
                            <Button
                              title="Create Technical Issues"
                              buttonName={"Create TI"}
                              onClick={() =>
                                this.props.history.push(`/technicalIssues`, {
                                  styleReferenceId: data._id,
                                  action: "add",
                                  _id: ""
                                })
                              }
                            />
                            <Button
                              title="View Technical Issues"
                              buttonName={"View TI"}
                              onClick={() =>
                                this.props.history.push(`/list`, {
                                  moduleName: "TECHNICALISSUES",
                                  type: "list",
                                  referenceId: data._id
                                })
                              }
                            />
                            <Button
                              buttonName={"Go to Top"}
                              onClick={() => {
                                var elmnt = document.getElementById('top')
                                if (elmnt != null) {
                                  elmnt.scrollIntoView({
                                    block: "start",
                                    behavior: "smooth",
                                    inline: "start"
                                  })
                                }
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            </form>
          </div>
        </div>
        <div id="myModal" class="modal fade" role="dialog">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-body no-padding">
                <div class="meeting-min-con">
                  <div class="row">
                    <div class="col-md-12 no-padding">
                      <div class="col-md-8 product-form no-padding">
                        <div class="col-md-6 nopadding">
                          <div class="col-md-12 step-one">
                            <div class="form-group">
                              <label for="phone">Search Style</label>
                              <br />
                              <span>BY</span>
                              <br />
                              <select
                                class="form-control"
                                name=""
                                onChange={e =>
                                  this.setState({
                                    searchMeetingNotesBy: e.target.value
                                  })
                                }
                              >
                                <option value="style">Select</option>
                                <option value="MNId">Meeting Notes No</option>
                                <option value="customerName">
                                  Customer Name
                                </option>
                                <option value="customerDepartment">
                                  Departement Name
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 no-padding">
                          <div class="col-md-12 step-one ">
                            <div class="form-group">
                              <label for="ref-no" />
                              <br />
                              <span>FOR</span>
                              <br />
                              <input
                                type="text"
                                class="form-control"
                                name="meetingNoteValue"
                                value={this.state.meetingNoteValue}
                                onChange={e =>
                                  this.setState({
                                    meetingNoteValue: e.target.value
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 product-form">
                        <div
                          class="col-md-12 mm-btns"
                          style={{ marginTop: "20%" }}
                        >
                          <button
                            type="button"
                            class="primary"
                            name="button"
                            onClick={e => this.searchMeetingNote(e)}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 no-padding">
                      <div class="table-container">
                        <table class="striped">
                          <thead>
                            <tr>
                              <th data-field="num">Meeting Notes No</th>
                              <th data-field="name">Customer Name</th>
                              <th data-field="name">Deptartment Name</th>
                              <th data-field="act">Action</th>
                              <th data-field="select">Select</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.meetingNotes !== undefined &&
                              Array.isArray(this.state.meetingNotes) &&
                              this.state.meetingNotes.length > 0 &&
                              this.state.meetingNotes.map(
                                (meetingNote, index) => (
                                  <tr>
                                    <td>
                                      {meetingNote.MNId !== null &&
                                        meetingNote.MNId}
                                    </td>
                                    <td>
                                      {meetingNote.customerName !== null &&
                                        meetingNote.customerName}
                                    </td>
                                    <td>
                                      {meetingNote.customerDepartmentName !==
                                        null &&
                                        meetingNote.customerDepartmentName}
                                    </td>
                                    <td>
                                      <a
                                        href=""
                                        class="view"
                                        title="View"
                                        onClick={() =>
                                          this.props.history.push(
                                            "/viewMeeting?" + meetingNote._id
                                          )
                                        }
                                      >
                                        <i class="material-icons">visibility</i>
                                      </a>
                                    </td>
                                    <td>
                                      <input
                                        type="radio"
                                        name="gender"
                                        data-dismiss="modal"
                                        class="sourcingOption"
                                        onClick={() =>
                                          this.setState({
                                            MNId: meetingNote.MNId,
                                            meetingNoteId: meetingNote._id
                                          })
                                        }
                                      />
                                      <br />
                                    </td>
                                  </tr>
                                )
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={this.state.openModal}
          onClose={() => this.setState({ openModal: false })}
          s
          center
        >

          {this.state.filePreviewIframe}
        </Modal>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    rights: state.main.rights.style,
  };
};

export default connect(mapStateToProps, null)(Style);


// WEBPACK FOOTER //
// ./src/pages/Style/page.js